var positionBufferData = [
  323.11651611328125,
  323.94647216796875,
  -17.568782806396484,
  321.64990234375,
  267.7066650390625,
  -31.925785064697266,
  321.6676330566406,
  285.19525146484375,
  -17.194509506225586,
  306.4206848144531,
  216.11929321289062,
  -23.553361892700195,
  321.1368103027344,
  251.257568359375,
  -33.84282302856445,
  320.308837890625,
  230.17721557617188,
  -31.289081573486328,
  318.3310546875,
  181.22036743164062,
  -14.797897338867188,
  210.6700897216797,
  183.96359252929688,
  8.644062042236328,
  317.1302490234375,
  148.72677612304688,
  -10.399860382080078,
  316.5323791503906,
  128.6800079345703,
  -11.26718521118164,
  314.0401611328125,
  52.11235046386719,
  -3.3319506645202637,
  323.38702392578125,
  332.09625244140625,
  -16.704530715942383,
  323.5595397949219,
  338.2655944824219,
  -14.759981155395508,
  323.5887756347656,
  340.659423828125,
  -12.136107444763184,
  323.96087646484375,
  342.1773681640625,
  -11.875374794006348,
  324.2167663574219,
  348.4466857910156,
  -12.978582382202148,
  324.48931884765625,
  356.75933837890625,
  -14.554830551147461,
  324.84228515625,
  366.36590576171875,
  -14.144981384277344,
  325.2572937011719,
  384.9513854980469,
  -8.975934028625488,
  321.7921142578125,
  276.28167724609375,
  -28.98696517944336,
  306.4281921386719,
  275.7503662109375,
  -20.878870010375977,
  159.87014770507812,
  131.3053741455078,
  37.14374923706055,
  254.20277404785156,
  194.42990112304688,
  2.7031404972076416,
  239.59185791015625,
  196.41848754882812,
  2.972090482711792,
  225.3127899169922,
  196.68807983398438,
  4.522538185119629,
  205.5539093017578,
  190.17918395996094,
  9.360472679138184,
  266.25823974609375,
  190.09291076660156,
  3.3210108280181885,
  232.54664611816406,
  161.1142578125,
  0.4966323971748352,
  248.14019775390625,
  161.02940368652344,
  0.7534967660903931,
  218.1525421142578,
  163.57833862304688,
  2.2705366611480713,
  208.49998474121094,
  168.55471801757812,
  4.669690132141113,
  194.8409423828125,
  200.6750030517578,
  12.155685424804688,
  267.7841796875,
  414.53961181640625,
  -1.8064359426498413,
  205.23828125,
  181.122802734375,
  10.508393287658691,
  154.94073486328125,
  197.5607452392578,
  38.3432731628418,
  178.42001342773438,
  191.921142578125,
  18.159528732299805,
  244.1207733154297,
  258.5937194824219,
  -3.900184154510498,
  303.1524658203125,
  321.52093505859375,
  -16.866844177246094,
  306.58087158203125,
  338.35498046875,
  -13.89834213256836,
  283.00830078125,
  327.0491027832031,
  -13.434535026550293,
  270.6599426269531,
  334.0726623535156,
  -9.07385540008545,
  291.79815673828125,
  339.4311828613281,
  -11.61515998840332,
  280.6661376953125,
  341.4773864746094,
  -7.595709800720215,
  253.0904083251953,
  359.0290832519531,
  -0.5970669388771057,
  308.47296142578125,
  267.54986572265625,
  -31.436981201171875,
  305.8460998535156,
  251.86883544921875,
  -33.17796325683594,
  185.6485137939453,
  153.70790100097656,
  6.360101699829102,
  273.1829833984375,
  218.42984008789062,
  -4.297842025756836,
  270.1053466796875,
  264.7032470703125,
  -16.802474975585938,
  268.9358215332031,
  256.55902099609375,
  -14.856505393981934,
  201.0337677001953,
  258.9792785644531,
  3.5506505966186523,
  305.99237060546875,
  232.39395141601562,
  -29.471277236938477,
  219.88006591796875,
  137.08212280273438,
  -3.7479465007781982,
  199.33328247070312,
  142.66859436035156,
  0.7038824558258057,
  171.93594360351562,
  102.62930297851562,
  25.879261016845703,
  285.7288818359375,
  146.78271484375,
  -8.614612579345703,
  262.0455322265625,
  164.37820434570312,
  2.617023468017578,
  240.76773071289062,
  344.6684875488281,
  1.1622507572174072,
  172.84420776367188,
  344.5473937988281,
  52.14391326904297,
  281.74786376953125,
  273.1513977050781,
  -14.525100708007812,
  295.11383056640625,
  278.23193359375,
  -15.336343765258789,
  257.3583984375,
  344.6321105957031,
  0.5829941630363464,
  264.4135437011719,
  343.39166259765625,
  -1.017601490020752,
  191.10064697265625,
  132.69065856933594,
  3.8590035438537598,
  269.67431640625,
  271.9882507324219,
  -13.59800910949707,
  248.12142944335938,
  137.29592895507812,
  -6.9757537841796875,
  244.83111572265625,
  124.17098999023438,
  -8.012014389038086,
  228.30499267578125,
  62.86616516113281,
  3.8345837593078613,
  181.92501831054688,
  116.54222106933594,
  13.413105964660645,
  238.1670684814453,
  91.65449523925781,
  -2.371932029724121,
  177.29916381835938,
  147.32359313964844,
  11.65469741821289,
  168.9032745361328,
  139.77952575683594,
  23.712440490722656,
  304.657470703125,
  331.4319152832031,
  -16.049942016601562,
  287.97210693359375,
  334.75262451171875,
  -12.795928955078125,
  275.8045959472656,
  338.0773620605469,
  -8.809469223022461,
  285.7834777832031,
  276.115234375,
  -13.412927627563477,
  261.038330078125,
  344.1378173828125,
  -0.24986127018928528,
  268.093505859375,
  345.9375,
  -4.172092914581299,
  266.13116455078125,
  342.62908935546875,
  -1.2260991334915161,
  290.6131896972656,
  267.3948974609375,
  -22.783634185791016,
  283.6044006347656,
  340.5296936035156,
  -6.641707897186279,
  295.03564453125,
  340.2284851074219,
  -9.275909423828125,
  308.5382080078125,
  340.4044189453125,
  -11.458096504211426,
  304.6598815917969,
  384.4068908691406,
  -8.751299858093262,
  305.5709228515625,
  365.5459289550781,
  -13.695691108703613,
  306.277099609375,
  355.4984130859375,
  -14.016304016113281,
  307.0936279296875,
  347.2339782714844,
  -12.360522270202637,
  308.20281982421875,
  342.0711975097656,
  -11.197815895080566,
  282.26275634765625,
  342.27349853515625,
  -6.5559587478637695,
  280.1040344238281,
  344.2525634765625,
  -7.676806926727295,
  276.89044189453125,
  348.6038513183594,
  -8.685104370117188,
  273.98187255859375,
  354.4639892578125,
  -7.716130256652832,
  256.96429443359375,
  315.8611145019531,
  -7.173637390136719,
  156.67434692382812,
  268.1974182128906,
  61.823402404785156,
  321.67657470703125,
  279.9446105957031,
  -21.204376220703125,
  274.7763671875,
  342.8690490722656,
  -3.4922499656677246,
  271.748291015625,
  343.65057373046875,
  -4.173834800720215,
  300.82440185546875,
  285.601806640625,
  -15.708353042602539,
  275.4014892578125,
  281.88909912109375,
  -9.427604675292969,
  298.0133056640625,
  282.04547119140625,
  -15.658348083496094,
  257.8790588378906,
  228.18124389648438,
  -2.3751800060272217,
  234.48097229003906,
  239.43783569335938,
  -0.8608551621437073,
  266.601318359375,
  263.881103515625,
  -11.564746856689453,
  193.27264404296875,
  79.32144165039062,
  13.976980209350586,
  203.66551208496094,
  99.89955139160156,
  4.993534564971924,
  214.192626953125,
  124.35659790039062,
  -2.3503618240356445,
  266.8046569824219,
  368.8791198730469,
  -3.8713901042938232,
  280.217041015625,
  126.4576416015625,
  -10.782143592834473,
  274.21429443359375,
  89.12802124023438,
  -6.5469970703125,
  267.3445739746094,
  54.692535400390625,
  -2.064028263092041,
  212.81898498535156,
  194.91871643066406,
  6.971029758453369,
  180.09385681152344,
  212.29409790039062,
  15.353899002075195,
  273.771484375,
  185.7499237060547,
  4.228655815124512,
  192.789306640625,
  172.89857482910156,
  9.732086181640625,
  283.6727600097656,
  207.76104736328125,
  -6.431457042694092,
  280.1270751953125,
  258.4156799316406,
  -22.589630126953125,
  165.6214141845703,
  224.11279296875,
  21.64031410217285,
  190.24551391601562,
  221.98941040039062,
  9.924493789672852,
  209.01893615722656,
  226.47073364257812,
  4.510352611541748,
  236.8439178466797,
  222.82125854492188,
  1.8049453496932983,
  257.20220947265625,
  215.456787109375,
  0.6790369749069214,
  272.492431640625,
  207.42327880859375,
  -0.8617515563964844,
  303.6573181152344,
  185.8953857421875,
  -12.504512786865234,
  168.3778076171875,
  256.185791015625,
  19.68412971496582,
  181.09927368164062,
  171.31813049316406,
  12.517826080322266,
  313.75042724609375,
  275.7742919921875,
  -28.656028747558594,
  274.2816162109375,
  233.32928466796875,
  -6.912413597106934,
  152.38613891601562,
  198.63865661621094,
  58.12936782836914,
  283.8626403808594,
  198.5483856201172,
  -1.6045750379562378,
  265.49407958984375,
  265.3607177734375,
  -5.484303951263428,
  200.5620574951172,
  182.45314025878906,
  11.547853469848633,
  278.98931884765625,
  248.54299926757812,
  -20.185150146484375,
  162.0050048828125,
  305.53851318359375,
  58.60392379760742,
  272.994140625,
  180.28761291503906,
  5.834909915924072,
  292.3125915527344,
  238.79739379882812,
  -25.972232818603516,
  202.45433044433594,
  379.2152099609375,
  20.797351837158203,
  204.62899780273438,
  398.7668762207031,
  30.881372451782227,
  156.33914184570312,
  262.9945373535156,
  40.65882110595703,
  184.59329223632812,
  358.08984375,
  28.37997055053711,
  161.83724975585938,
  166.27520751953125,
  32.74825668334961,
  264.6654357910156,
  433.0896301269531,
  1.4305986166000366,
  315.250244140625,
  279.32794189453125,
  -20.81725311279297,
  261.2689208984375,
  245.606689453125,
  -4.830883979797363,
  166.9665069580078,
  195.82589721679688,
  24.034517288208008,
  225.92388916015625,
  187.05523681640625,
  5.200074195861816,
  238.94944763183594,
  187.44232177734375,
  3.7697904109954834,
  264.1736145019531,
  349.2875061035156,
  -3.1675024032592773,
  171.58206176757812,
  287.9273376464844,
  21.306987762451172,
  293.95599365234375,
  457.10064697265625,
  2.6667895317077637,
  246.57467651367188,
  434.9912109375,
  14.810300827026367,
  226.7908172607422,
  419.973388671875,
  21.8872013092041,
  315.3326416015625,
  88.80404663085938,
  -7.664234161376953,
  327.2855224609375,
  459.603759765625,
  1.0371936559677124,
  251.32020568847656,
  185.9434814453125,
  3.591391086578369,
  262.6206359863281,
  183.20826721191406,
  4.425485134124756,
  269.65252685546875,
  181.5925750732422,
  5.718056678771973,
  171.45248413085938,
  168.89012145996094,
  18.5508975982666,
  260.152099609375,
  172.79396057128906,
  3.693479537963867,
  247.5819549560547,
  170.77157592773438,
  2.508162260055542,
  235.03382873535156,
  170.6088409423828,
  2.6751668453216553,
  222.2652587890625,
  173.05519104003906,
  4.039044380187988,
  213.94973754882812,
  176.4881591796875,
  5.945765972137451,
  153.9766845703125,
  161.3706817626953,
  49.039398193359375,
  216.9583282470703,
  185.66758728027344,
  7.032083511352539,
  322.1541442871094,
  297.5083312988281,
  -16.00879669189453,
  269.7311706542969,
  305.6127624511719,
  -10.331046104431152,
  281.48126220703125,
  270.48370361328125,
  -16.717947006225586,
  300.04461669921875,
  299.4017333984375,
  -15.656883239746094,
  317.66339111328125,
  164.8524627685547,
  -10.237009048461914,
  222.44737243652344,
  400.28460693359375,
  14.630343437194824,
  242.59323120117188,
  416.992431640625,
  8.299786567687988,
  292.862060546875,
  443.7979736328125,
  -4.521420001983643,
  187.72213745117188,
  375.5125427246094,
  41.960391998291016,
  268.95684814453125,
  176.8852081298828,
  4.970767021179199,
  294.11273193359375,
  210.64590454101562,
  -14.587058067321777,
  327.2318115234375,
  446.44342041015625,
  -5.906525611877441,
  268.2618408203125,
  448.0268859863281,
  7.456300258636475,
  161.5745849609375,
  297.48333740234375,
  39.41569519042969,
  294.0351257324219,
  341.7873840332031,
  -9.140814781188965,
  291.95458984375,
  345.6842956542969,
  -10.367130279541016,
  289.845947265625,
  352.1710205078125,
  -11.577893257141113,
  288.1461486816406,
  361.09893798828125,
  -11.053465843200684,
  283.66680908203125,
  377.870361328125,
  -7.087894439697266,
  270.8735046386719,
  342.74639892578125,
  -4.103464603424072,
  266.14617919921875,
  341.66937255859375,
  -4.162796974182129,
  261.54791259765625,
  339.3941345214844,
  -4.1746826171875,
  246.18902587890625,
  329.3245849609375,
  -2.961322546005249,
  190.56277465820312,
  294.2333984375,
  9.390547752380371,
  293.86993408203125,
  195.8378448486328,
  -9.012523651123047,
  285.0931091308594,
  169.88436889648438,
  1.7015331983566284,
  275.52679443359375,
  172.66934204101562,
  3.9000771045684814,
  274.2338562011719,
  340.83880615234375,
  -3.529534101486206,
  189.50616455078125,
  333.734619140625,
  17.67523956298828,
  298.2148742675781,
  168.2777862548828,
  -6.0877814292907715,
  275.1707458496094,
  395.8807373046875,
  -4.150460243225098,
  319.609375,
  213.20645141601562,
  -25.531686782836914,
  304.7801818847656,
  201.61163330078125,
  -18.585384368896484,
  318.9832458496094,
  197.57528686523438,
  -19.884870529174805,
  283.4682312011719,
  235.45059204101562,
  -14.688872337341309,
  326.6484069824219,
  427.47015380859375,
  -9.102132797241211,
  325.87774658203125,
  404.880126953125,
  -8.94002914428711,
  299.8717041015625,
  403.94073486328125,
  -7.80373477935791,
  238.68128967285156,
  367.0010986328125,
  2.7526659965515137,
  253.98707580566406,
  278.80322265625,
  -4.358704566955566,
  255.34938049316406,
  383.8130798339844,
  -0.5109075903892517,
  221.5740203857422,
  278.1018981933594,
  -1.8077586889266968,
  241.415771484375,
  295.5854797363281,
  -3.5574092864990234,
  209.53550720214844,
  304.8381042480469,
  2.743500232696533,
  294.94976806640625,
  425.327880859375,
  -7.4867353439331055,
  274.0611572265625,
  244.91165161132812,
  -10.546663284301758,
  226.30633544921875,
  380.7353515625,
  8.176047325134277,
  246.79827880859375,
  398.94097900390625,
  3.8866376876831055,
  225.9365234375,
  347.2131042480469,
  3.8363399505615234,
  175.85333251953125,
  315.1534729003906,
  23.08595848083496,
  207.78817749023438,
  350.5667724609375,
  9.71776008605957,
  169.63876342773438,
  329.195556640625,
  36.44424057006836,
  230.44189453125,
  317.53167724609375,
  -0.9267317652702332,
  284.35980224609375,
  221.7354736328125,
  -10.449814796447754,
  285.5650634765625,
  264.9780578613281,
  -23.92240333557129,
  274.9562683105469,
  269.5750732421875,
  -17.530813217163086,
  292.2945861816406,
  254.3388671875,
  -28.237804412841797,
  273.01220703125,
  158.96517944335938,
  -0.09002730250358582,
  248.7141571044922,
  152.65328979492188,
  -1.389674425125122,
  227.8582763671875,
  151.95883178710938,
  -1.2474606037139893,
  210.54685974121094,
  154.68576049804688,
  1.0268592834472656,
  198.41705322265625,
  161.3450469970703,
  4.723947048187256,
  191.10504150390625,
  186.9726104736328,
  13.84589958190918,
  153.60556030273438,
  229.93136596679688,
  39.786155700683594,
  202.93617248535156,
  206.47616577148438,
  9.13370418548584,
  218.19210815429688,
  209.81057739257812,
  5.49985933303833,
  237.618408203125,
  208.71490478515625,
  3.108225107192993,
  256.08367919921875,
  204.24436950683594,
  2.2745330333709717,
  270.3304138183594,
  198.43910217285156,
  2.0658209323883057,
  280.03753662109375,
  192.8920440673828,
  1.8290718793869019,
  154.55300903320312,
  233.4366455078125,
  61.95684814453125,
  275.45025634765625,
  273.9498596191406,
  -14.600406646728516,
  294.47747802734375,
  224.07571411132812,
  -19.41942596435547,
  297.1092529296875,
  265.4220275878906,
  -28.585128784179688,
  305.83050537109375,
  273.2985534667969,
  -26.266172409057617,
  297.0882568359375,
  268.02960205078125,
  -25.710546493530273,
  280.0792236328125,
  278.9830322265625,
  -12.655070304870605,
  308.76202392578125,
  274.71514892578125,
  -27.840410232543945,
  310.0816345214844,
  278.26849365234375,
  -20.86105728149414,
  278.5430603027344,
  181.00303649902344,
  4.947571754455566,
  287.54656982421875,
  184.307861328125,
  1.260591745376587,
  292.3014831542969,
  186.36598205566406,
  -3.143568992614746,
  209.09744262695312,
  179.09437561035156,
  7.914038181304932,
  201.1513214111328,
  174.12767028808594,
  8.084104537963867,
  332.9224853515625,
  215.6724853515625,
  -23.370018005371094,
  424.55767822265625,
  180.68113708496094,
  9.830978393554688,
  336.6293640136719,
  275.2829284667969,
  -20.78504180908203,
  469.8965148925781,
  125.57901000976562,
  38.99407958984375,
  382.28717041015625,
  192.43331909179688,
  3.4612600803375244,
  396.9390869140625,
  193.86790466308594,
  3.8914084434509277,
  411.00787353515625,
  193.62002563476562,
  5.549503803253174,
  429.71795654296875,
  186.66195678710938,
  10.617892265319824,
  370.05230712890625,
  188.40982055664062,
  3.9252419471740723,
  401.5653991699219,
  158.86630249023438,
  1.4472987651824951,
  386.22540283203125,
  159.340087890625,
  1.508786678314209,
  415.85626220703125,
  160.82952880859375,
  3.381333351135254,
  425.4224853515625,
  165.43167114257812,
  5.918134689331055,
  440.8648986816406,
  196.23458862304688,
  13.489381790161133,
  383.5614013671875,
  412.1856689453125,
  -1.2763981819152832,
  429.66766357421875,
  177.68446350097656,
  11.750621795654297,
  478.7536926269531,
  191.44679260253906,
  40.292274475097656,
  456.2593688964844,
  187.05970764160156,
  19.656951904296875,
  396.70855712890625,
  255.54208374023438,
  -3.1392972469329834,
  342.8689270019531,
  320.60870361328125,
  -16.659250259399414,
  340.4381408691406,
  337.6176452636719,
  -13.7393217086792,
  363.13134765625,
  325.23089599609375,
  -12.994629859924316,
  375.7514953613281,
  331.7568359375,
  -8.478598594665527,
  355.1566162109375,
  338.01800537109375,
  -11.234922409057617,
  366.4199523925781,
  339.488037109375,
  -7.100727081298828,
  394.68389892578125,
  356.0306396484375,
  0.13269051909446716,
  334.7259216308594,
  267.0843811035156,
  -31.326902389526367,
  336.2799377441406,
  251.33706665039062,
  -33.022640228271484,
  446.9028625488281,
  149.9997100830078,
  7.749013900756836,
  365.2566833496094,
  216.65200805664062,
  -3.8045411109924316,
  371.8299865722656,
  262.5707702636719,
  -16.28518295288086,
  372.3122253417969,
  254.44293212890625,
  -14.348434448242188,
  439.06005859375,
  254.14584350585938,
  4.803002834320068,
  334.6656799316406,
  231.83706665039062,
  -29.320056915283203,
  412.4833679199219,
  134.77537536621094,
  -2.8003480434417725,
  432.9185485839844,
  139.5846405029297,
  1.896531343460083,
  456.6582336425781,
  97.67573547363281,
  27.524517059326172,
  348.30828857421875,
  146.11997985839844,
  -8.290468215942383,
  372.6208801269531,
  162.8184356689453,
  3.228713274002075,
  406.0555419921875,
  341.1844787597656,
  2.0252270698547363,
  469.9366149902344,
  338.3891296386719,
  53.86491394042969,
  360.842041015625,
  271.5228271484375,
  -14.121028900146484,
  347.8482360839844,
  277.2429504394531,
  -15.139877319335938,
  389.7527770996094,
  341.73504638671875,
  1.3748646974563599,
  382.7810974121094,
  340.7091064453125,
  -0.3233203589916229,
  440.296630859375,
  129.44049072265625,
  5.1410088539123535,
  372.5621643066406,
  269.7780456542969,
  -13.115525245666504,
  384.7712707519531,
  135.73818969726562,
  -6.309181213378906,
  387.2312316894531,
  122.5787353515625,
  -7.326788425445557,
  399.4652099609375,
  60.144744873046875,
  4.721075057983398,
  448.0954895019531,
  112.34931945800781,
  14.905879974365234,
  391.7792663574219,
  89.46018981933594,
  -1.5736668109893799,
  454.69744873046875,
  143.20791625976562,
  13.139555931091309,
  462.18414306640625,
  134.90118408203125,
  25.395933151245117,
  342.05596923828125,
  330.6085510253906,
  -15.849852561950684,
  358.6634216308594,
  333.08514404296875,
  -12.385476112365723,
  371.0511474609375,
  335.9906005859375,
  -8.29167366027832,
  356.9338073730469,
  274.68096923828125,
  -13.09109878540039,
  386.1968078613281,
  341.385986328125,
  0.4633089601993561,
  379.505615234375,
  343.56292724609375,
  -3.58079195022583,
  380.99072265625,
  339.9813537597656,
  -0.56928950548172,
  351.92706298828125,
  266.1675109863281,
  -22.411170959472656,
  363.1768798828125,
  338.68280029296875,
  -6.149283409118652,
  351.8752136230469,
  338.9214782714844,
  -8.935256958007812,
  338.43121337890625,
  339.7230224609375,
  -11.266111373901367,
  345.47833251953125,
  383.5452880859375,
  -8.54257869720459,
  343.7301940917969,
  364.6892395019531,
  -13.523378372192383,
  342.5115051269531,
  354.8351135253906,
  -13.84434986114502,
  341.0390930175781,
  346.5924072265625,
  -12.141350746154785,
  339.55938720703125,
  341.4112854003906,
  -11.004034996032715,
  365.00738525390625,
  340.4651794433594,
  -6.095052242279053,
  367.36639404296875,
  342.3319396972656,
  -7.191629409790039,
  370.9842224121094,
  346.59893798828125,
  -8.184698104858398,
  374.2361755371094,
  352.38916015625,
  -7.224337100982666,
  388.0760803222656,
  312.992431640625,
  -6.49540376663208,
  480.3379821777344,
  261.6239013671875,
  63.763389587402344,
  372.50164794921875,
  340.673095703125,
  -2.910421848297119,
  375.647216796875,
  341.3985290527344,
  -3.5980868339538574,
  342.5552673339844,
  284.8035583496094,
  -15.550444602966309,
  367.3857421875,
  280.0863342285156,
  -9.014886856079102,
  345.03631591796875,
  281.2030029296875,
  -15.500083923339844,
  381.04669189453125,
  225.75692749023438,
  -1.7069110870361328,
  404.9681091308594,
  236.08831787109375,
  -0.008579621091485023,
  374.9254150390625,
  261.70758056640625,
  -11.010907173156738,
  434.6033935546875,
  75.28443145751953,
  15.280303001403809,
  425.8450927734375,
  96.6444091796875,
  6.181840419769287,
  417.2605285644531,
  121.89888000488281,
  -1.3361674547195435,
  381.77252197265625,
  366.4750061035156,
  -3.2928552627563477,
  352.6125793457031,
  125.71281433105469,
  -10.41528606414795,
  356.1432189941406,
  87.92901611328125,
  -6.096003532409668,
  360.54925537109375,
  53.24565887451172,
  -1.6013318300247192,
  423.0085144042969,
  191.4607391357422,
  8.192007064819336,
  455.9168701171875,
  207.06011962890625,
  16.840869903564453,
  362.320556640625,
  184.3780059814453,
  4.786047458648682,
  441.0181579589844,
  169.07571411132812,
  11.076071739196777,
  354.32940673828125,
  206.4979248046875,
  -6.017457962036133,
  361.7270812988281,
  256.7944030761719,
  -22.147241592407227,
  470.78857421875,
  218.2230224609375,
  23.366037368774414,
  446.9043884277344,
  217.05377197265625,
  11.335209846496582,
  428.977783203125,
  222.14804077148438,
  5.704945087432861,
  401.39324951171875,
  219.66403198242188,
  2.709503650665283,
  380.70123291015625,
  213.15652465820312,
  1.3608025312423706,
  365.122802734375,
  205.7574920654297,
  -0.3050336539745331,
  333.2375793457031,
  185.38961791992188,
  -12.339582443237305,
  470.42559814453125,
  250.09902954101562,
  21.368783950805664,
  452.41015625,
  166.84707641601562,
  14.01742935180664,
  329.67291259765625,
  275.4928894042969,
  -28.54446029663086,
  365.2168884277344,
  231.57791137695312,
  -6.41494607925415,
  480.26104736328125,
  192.2894287109375,
  60.1459846496582,
  353.3818359375,
  197.30165100097656,
  -1.2043124437332153,
  375.92144775390625,
  263.09228515625,
  -4.952785968780518,
  434.0610656738281,
  178.89532470703125,
  12.865796089172363,
  362.0376892089844,
  246.83267211914062,
  -19.729684829711914,
  477.7235412597656,
  299.0860290527344,
  60.44133758544922,
  362.7712707519531,
  178.93336486816406,
  6.433119297027588,
  348.4642639160156,
  237.6964111328125,
  -25.6434268951416,
  444.9437255859375,
  374.3408203125,
  22.08431625366211,
  443.3897399902344,
  393.920654296875,
  32.19438171386719,
  481.78631591796875,
  256.505615234375,
  42.56291961669922,
  460.74566650390625,
  352.44598388671875,
  29.870811462402344,
  470.4197998046875,
  160.69410705566406,
  34.579654693603516,
  387.6665344238281,
  430.642333984375,
  2.0062272548675537,
  328.07861328125,
  279.17724609375,
  -20.75840950012207,
  378.8198547363281,
  243.26248168945312,
  -4.24747371673584,
  467.50250244140625,
  190.25503540039062,
  25.744525909423828,
  409.82464599609375,
  184.141357421875,
  6.231921195983887,
  397.0033264160156,
  185.0110321044922,
  4.7111334800720215,
  383.4640197753906,
  346.753662109375,
  -2.522388458251953,
  469.2848205566406,
  281.7126159667969,
  22.92217445373535,
  360.1937255859375,
  455.74932861328125,
  2.9791202545166016,
  405.12158203125,
  431.91900634765625,
  15.62734603881836,
  423.4313049316406,
  416.1868591308594,
  22.959041595458984,
  384.67138671875,
  183.9629364013672,
  4.3632402420043945,
  373.213623046875,
  181.48912048339844,
  5.123116970062256,
  366.1402893066406,
  180.15541076660156,
  6.310164928436279,
  461.6444091796875,
  163.96163940429688,
  20.155040740966797,
  374.98333740234375,
  171.23558044433594,
  4.387862682342529,
  387.49774169921875,
  168.8740692138672,
  3.304352283477783,
  399.94378662109375,
  168.39108276367188,
  3.634413242340088,
  412.6290588378906,
  170.36415100097656,
  5.1217498779296875,
  420.96893310546875,
  173.51547241210938,
  7.114045143127441,
  476.9218444824219,
  155.16864013671875,
  50.95864486694336,
  418.4987487792969,
  182.4808807373047,
  8.162747383117676,
  374.7021179199219,
  303.31707763671875,
  -9.819207191467285,
  360.9924621582031,
  268.89068603515625,
  -16.321969985961914,
  344.3481140136719,
  298.4349365234375,
  -15.438346862792969,
  426.8325500488281,
  396.30877685546875,
  15.641507148742676,
  408.3316955566406,
  413.7490539550781,
  9.129907608032227,
  360.76519775390625,
  442.39337158203125,
  -4.226146221160889,
  457.8586120605469,
  370.0028991699219,
  43.47062301635742,
  366.5082092285156,
  175.42959594726562,
  5.558383464813232,
  344.51177978515625,
  209.68707275390625,
  -14.27273941040039,
  384.7861022949219,
  445.6679382324219,
  8.124580383300781,
  478.9347229003906,
  290.98956298828125,
  41.21711349487305,
  353.3740539550781,
  340.5323486328125,
  -8.78250789642334,
  355.8246154785156,
  344.3572082519531,
  -9.997100830078125,
  358.39141845703125,
  350.72332763671875,
  -11.240950584411621,
  360.680419921875,
  359.6910400390625,
  -10.636283874511719,
  365.86053466796875,
  376.1639099121094,
  -6.660977363586426,
  376.22296142578125,
  340.27056884765625,
  -3.5048739910125732,
  380.8910217285156,
  339.0758972167969,
  -3.475714921951294,
  385.29180908203125,
  336.63427734375,
  -3.401749610900879,
  399.6767883300781,
  325.93450927734375,
  -2.128159523010254,
  451.57861328125,
  288.81036376953125,
  10.718208312988281,
  343.4667053222656,
  194.96011352539062,
  -8.735547065734863,
  350.09100341796875,
  169.0031280517578,
  2.0712971687316895,
  359.6502990722656,
  171.5241241455078,
  4.450891017913818,
  372.62359619140625,
  338.539794921875,
  -2.956547975540161,
  454.8492431640625,
  328.1819152832031,
  19.078685760498047,
  337.1347351074219,
  167.7401123046875,
  -5.871736526489258,
  375.0529479980469,
  393.76483154296875,
  -3.6778383255004883,
  333.4227294921875,
  201.0952911376953,
  -18.425695419311523,
  356.4927062988281,
  234.01895141601562,
  -14.301460266113281,
  351.2936706542969,
  402.79620361328125,
  -7.5585551261901855,
  409.10919189453125,
  363.5516357421875,
  3.57236647605896,
  388.25555419921875,
  276.1095275878906,
  -3.709625244140625,
  393.75286865234375,
  380.920166015625,
  0.1369001269340515,
  420.40191650390625,
  273.9984436035156,
  -0.8729774355888367,
  401.9803161621094,
  292.1586608886719,
  -2.742661714553833,
  433.86163330078125,
  300.2438659667969,
  3.79644513130188,
  357.5480041503906,
  424.0931091308594,
  -7.21943998336792,
  366.2776184082031,
  243.02346801757812,
  -10.05320930480957,
  422.03759765625,
  376.86553955078125,
  9.139190673828125,
  403.22271728515625,
  395.7782897949219,
  4.615209102630615,
  420.5649108886719,
  343.19183349609375,
  4.793065071105957,
  466.7944641113281,
  309.1900329589844,
  24.664592742919922,
  438.3085021972656,
  345.8584899902344,
  10.867822647094727,
  473.22900390625,
  323.0245361328125,
  38.14845275878906,
  414.3385925292969,
  313.6124267578125,
  0.012857065536081791,
  354.69293212890625,
  220.4129638671875,
  -10.033292770385742,
  356.8241271972656,
  263.5083312988281,
  -23.556297302246094,
  367.4049072265625,
  267.6433410644531,
  -17.09963607788086,
  349.74609375,
  253.279541015625,
  -27.92021942138672,
  361.42388916015625,
  157.93853759765625,
  0.41821685433387756,
  385.1235046386719,
  150.96600341796875,
  -0.6607803106307983,
  405.5707702636719,
  149.6215057373047,
  -0.3118784427642822,
  422.8327941894531,
  151.75064086914062,
  2.1794090270996094,
  434.8728332519531,
  158.0150146484375,
  5.985780239105225,
  443.5646667480469,
  182.8747100830078,
  15.249552726745605,
  482.15576171875,
  223.59829711914062,
  41.767704010009766,
  433.39141845703125,
  202.36753845214844,
  10.402255058288574,
  418.7890625,
  206.17379760742188,
  6.606390953063965,
  399.58636474609375,
  205.84176635742188,
  4.021158218383789,
  381.0849609375,
  202.08261108398438,
  3.0047805309295654,
  366.6188659667969,
  196.7928924560547,
  2.618781566619873,
  356.5893859863281,
  191.5957794189453,
  2.271151542663574,
  480.2386474609375,
  226.94879150390625,
  63.96815872192383,
  367.0486755371094,
  272.0451965332031,
  -14.173871994018555,
  345.1959228515625,
  223.20333862304688,
  -19.10439682006836,
  345.7338562011719,
  264.4343566894531,
  -28.369665145874023,
  337.3208312988281,
  272.7472839355469,
  -26.105701446533203,
  345.6841125488281,
  267.1420593261719,
  -25.44144630432129,
  362.701171875,
  277.2493591308594,
  -12.29609489440918,
  334.5038757324219,
  274.249267578125,
  -27.719623565673828,
  333.1357727050781,
  277.93988037109375,
  -20.768848419189453,
  357.30718994140625,
  179.84762573242188,
  5.402637004852295,
  348.57269287109375,
  183.3765869140625,
  1.6270942687988281,
  344.1528015136719,
  185.49330139160156,
  -2.848400592803955,
  425.8621520996094,
  175.94349670410156,
  9.125075340270996,
  432.9592590332031,
  170.6381378173828,
  9.381414413452148
];